export const SET_ACCOMMODATION = 'SET_ACCOMMODATION';